// utils/realtimeManager/types.ts - utils/realtimeManager.ts split (sub-module types)

import type {RealtimeChannel, RealtimePostgresChangesPayload} from '@supabase/supabase-js';


export interface SubscriptionConfig {
  channelName: string;
  event: 'INSERT' | 'UPDATE' | 'DELETE' | '*';
  schema?: string;
  table: string;
  filter?: string;
  callback: (payload: RealtimePostgresChangesPayload<any>) => void;
}



export interface ResilientChannel {
  channel: RealtimeChannel | null;
  unsubscribe: () => void;
}



export const MAX_RETRIES = 10;


export const BASE_DELAY = 5000;

 // 5 seconds
export const MAX_DELAY = 60000;

 // 60 seconds
// After max retries, wait this long before retrying on visibility change
export const VISIBILITY_COOLDOWN = 60000;
